import PropTypes from 'prop-types';

const displayName = 'AdminDashboard';
const propTypes = {};
const defaultProps = {
  headerTable: [
    {
      width: 200,
      title: 'Invoice Number',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
      sort: true,
    },
    {
      width: 250,
      title: 'Client Name',
      dataIndex: 'brand_name',
      key: 'brand_name',
      sort: true,
    },
    {
      width: 150,
      title: 'Type',
      dataIndex: 'invoice_type',
      key: 'invoice_type',
      sort: true,
    },
    {
      width: 200,
      title: 'Project Name',
      dataIndex: 'project_name',
      key: 'project_name',
      sort: true,
    },
    {
      width: 200,
      title: 'Created at',
      dataIndex: 'invoice_created_at',
      key: 'invoice_created_at',
      formatDate: true,
      sortFormatDate: true,
    },
    {
      width: 200,
      title: 'Due Date',
      dataIndex: 'invoice_due_date',
      key: 'invoice_due_date',
      formatDate: true,
      sortFormatDate: true,
      defaultSortOrder: 'desc',
    },
    {
      width: 200,
      title: 'Total Amount',
      dataIndex: 'total_amout',
      key: 'total_amout',
      formatCurrency: 'Rp.',
      sortFormatNumber: true,
    },
    {
      width: 100,
      title: 'Status',
      dataIndex: 'invoice_status_transaction',
      key: 'invoice_status_transaction',
      sort: true,
    },
    {
      width: 200,
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      actionRows: true,
      fixed: 'right',
    },
  ],
};

export default { displayName, propTypes, defaultProps };
